// extracted by mini-css-extract-plugin
export default {"container":"InfoButton_container__ASAun","info":"InfoButton_info__LKbv6","GameOver":"InfoButton_GameOver__YP45I"};